<template>
  <div class="popular-list container section mt-4">
    <h2 class="headline mb-5" align="center">다른 사람들의 세줄을 감상해보세요</h2>
    <div class="cards" v-for="card in cards" :key="card.title">
      <v-card shaped class="my-4 pt-4 px-5" hover @click="gotoView(card.id)">
        <v-card-text class="pb-0">
          <div class="title black--text">{{ card.title }}</div>
          <div class="grey--text mb-3">{{ card.author }}</div>
          <p class="black--text content">{{ card.content }}</p>
        </v-card-text>
        <v-card-actions>
          <v-btn text color="orange accent-4">
            링크 3줄 쓰기
          </v-btn>
          <v-spacer></v-spacer>
          <span class="links">
            <span>{{ card.links }}</span>
            <v-icon small color="grey">mdi-fountain-pen-tip</v-icon>
          </span>
          <span class="likes ml-4">
            <span>{{ card.likes }}</span>
            <v-icon small color="pink">mdi-heart-outline</v-icon>
          </span>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import db from '@/firebase/init'

export default {
  name: 'popularList',
  data() {
    return {
      cards: []
    }
  },
  methods: {
    gotoView(id) {
      this.$router.push({ name: 'content', params: { id: id } })
    }
  },
  created() {
    db.collection('contents').get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          let content = doc.data()
          content.id = doc.id
          if(!content.img) {
            this.cards.push(content)
          }
        })
      })
  }
}
</script>

<style>
.popular-list {
  margin-bottom: 60px;
}

.popular-list .content {
  font-size: 1.3em;
  font-weight: 300;
}
</style>